import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../colorVars';
// old green '#0acc00'
//old blue '#0b52a8' 
const TULogo = ({ width, height, margin }) => {
  return (
    <div style={{ height: 'fit-content', width: 'fit-content', margin }}>
      <svg width={width} height={height} viewBox="30 20 200 80">
        <g
          id="g1652"
          transform="matrix(0.35277777,0,0,-0.35277777,109.91955,65.80063)"
        >
          <path
            d="M 0,0 C 6.408,0.968 15.304,4.877 16.814,6.692 6.982,2.984 -3.202,1.396 -13.649,0.638 c 0.472,-0.163 0.882,-0.305 1.294,-0.444 0.4,-0.136 0.88,0.087 1.221,-0.454 -6.051,-0.238 -12.04,0.458 -18.017,1.35 C -18.798,-3.594 -8.029,-2.43 2.891,-1.296 2.046,-0.309 0.615,-1.108 0,0 M 26.944,9.088 C 26.693,9.017 26.669,8.717 26.701,8.432 26.732,8.155 27.012,8.248 27.192,8.205 28.85,7.808 30.507,7.413 32.367,6.969 31.012,5.625 29.562,4.745 28.169,3.819 23.731,0.872 19.034,-1.589 14.019,-3.407 8.736,-5.322 3.271,-5.955 -2.333,-5.857 c -6.232,0.107 -12.347,1.054 -18.455,2.153 -1.285,0.232 -2.573,0.436 -3.838,0.76 -2.167,0.555 -3.752,-0.622 -5.343,-1.782 -0.58,-0.423 -1.061,-0.985 -1.875,-1.318 0.293,5.712 0.753,11.353 -0.441,16.99 C -17.203,3.83 -2.023,4.219 13.264,9.799 12.19,10.155 11.153,9.744 10.145,9.536 5.2,8.517 0.224,8.011 -4.824,8.191 c -2.915,0.104 -5.743,0.732 -8.526,1.521 -3.12,0.885 -6.223,1.872 -8.976,3.663 -1.403,0.913 -2.757,1.959 -3.328,3.612 -0.682,1.975 -0.149,3.783 1.18,5.329 2.162,2.514 4.895,4.024 8.2,4.459 -0.187,-0.904 -1.054,-1.183 -1.644,-1.669 -2.586,-2.126 -3.336,-5.611 -1.673,-8.445 0.365,-0.622 0.814,-1.279 1.393,-1.668 0.589,-0.396 1.072,0.373 1.622,0.576 3.711,1.374 7.584,1.881 11.497,1.965 3.343,0.071 6.649,-0.399 9.919,-1.167 3.045,-0.714 6.062,-1.522 8.987,-2.613 2.225,-0.83 4.521,-1.472 6.678,-2.494 -8.371,6.015 -17.217,10.974 -27.629,12.587 3.136,0.641 6.298,0.292 9.445,0.31 3.335,-1.31 6.467,-3.038 9.615,-4.725 2.217,-1.189 4.32,-2.583 6.552,-3.745 0.192,-0.1 0.415,-0.157 0.719,-0.272 -0.53,1.889 -1.012,3.679 -1.535,5.457 -1.716,5.832 -2.923,11.772 -3.947,17.76 -1.311,7.664 -1.351,15.382 -0.987,23.097 0.213,4.514 0.774,9.023 1.616,13.48 0.128,0.684 -0.087,1.009 -0.733,0.691 -3.894,-1.919 -7.485,-0.831 -10.892,1.222 -0.922,0.555 -2.132,0.452 -2.894,-0.308 -0.637,-0.636 -1.439,-1.109 -2.154,-1.67 -0.506,-0.396 -1.127,-0.732 -0.399,-1.515 0.646,-0.694 1.312,-1.017 2.087,-0.332 0.674,0.595 1.309,1.209 2.16,1.559 1.126,0.463 2.135,0.146 2.933,-0.97 C 5.253,72.781 5.187,72.117 4.193,71.083 3.316,70.169 2.367,69.32 1.307,68.649 c -2.648,-1.674 -5.75,-1.016 -7.723,1.642 -0.291,0.393 -0.877,0.661 -0.82,1.292 -0.076,1.201 -0.108,2.406 -0.239,3.6 -0.164,1.495 -0.418,2.979 -0.616,4.47 -0.097,0.734 0.23,1.173 0.892,1.561 1.335,0.783 2.732,1.442 4.142,2.05 0.607,0.261 1.158,0.866 1.935,0.717 0.064,-0.69 -0.827,-0.666 -0.848,-1.26 0.139,-0.019 0.231,-0.062 0.295,-0.036 4.323,1.713 8.862,1.989 13.436,1.979 2.26,-0.005 3.153,-0.71 3.99,-2.73 1.304,-3.149 1.907,-6.458 2.376,-9.805 0.733,-5.238 1.686,-10.436 2.954,-15.573 1.283,-5.202 3.341,-10.178 4.576,-15.393 0.663,-2.801 1.376,-5.616 1.695,-8.466 0.485,-4.341 1.111,-8.689 1.061,-13.136 0.542,2.082 1.084,4.164 1.711,6.571 1.147,-3.689 1.027,-7.113 1.057,-10.531 0.016,-1.922 -0.986,-3.577 -1.975,-4.834 -0.637,-0.665 -1.289,-1.355 -2.262,-1.679"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1654"
          />
        </g>
        <g
          id="g1656"
          transform="matrix(0.35277777,0,0,-0.35277777,101.44548,55.14237)"
        >
          <path
            d="m 0,0 c -0.052,0.023 -0.105,0.041 -0.161,0.052 -0.12,0.017 -0.184,0.003 -0.378,0.027 -3.021,0.483 -5.958,0.316 -8.915,-0.631 -3.754,-1.202 -6.526,-3.425 -8.514,-6.814 -2.329,-3.971 -3.749,-8.281 -4.983,-12.661 -0.638,-2.265 -1.035,-4.598 -1.541,-6.899 -0.072,-0.137 -0.217,-0.281 -0.204,-0.409 0.282,-2.771 0.056,-5.549 0.134,-8.322 0.006,-0.218 -0.111,-0.507 0.333,-0.637 1.885,1.838 3.401,4.027 4.895,6.228 2.617,3.856 4.101,8.24 5.845,12.511 2.804,6.868 6.934,12.693 13.556,16.433 C 0.849,-0.681 0.806,-0.327 0,0"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1658"
          />
        </g>
        <g
          id="g1660"
          transform="matrix(0.35277777,0,0,-0.35277777,121.35072,61.71007)"
        >
          <path
            d="m 0,0 c -1.06,-1.375 -2.811,-1.818 -4.351,-2.453 -0.286,-0.118 -0.574,-0.236 -0.877,-0.299 -0.213,-0.044 -0.473,-0.383 -0.473,-0.383 0,0 0.273,-0.228 0.496,-0.282 1.637,-0.391 3.273,-0.781 5.107,-1.219 0.008,-0.028 0.01,-0.036 0.019,-0.064 -1.342,-1.318 -2.773,-2.187 -4.15,-3.102 -4.437,-2.948 -9.134,-5.408 -14.15,-7.226 -5.282,-1.915 -10.748,-2.548 -16.352,-2.451 -6.232,0.108 -12.346,1.055 -18.455,2.154 -1.285,0.232 -2.573,0.436 -3.838,0.76 -2.167,0.555 -3.752,-0.623 -5.343,-1.782 -0.58,-0.423 -1.061,-0.985 -1.875,-1.318 0.292,5.69 0.75,11.309 -0.426,16.923 -0.006,0.028 0.022,0.05 0.047,0.038 15.061,-7.087 30.221,-6.69 45.486,-1.118 -1.073,0.356 -2.109,-0.055 -3.118,-0.263 -4.945,-1.019 -9.922,-1.524 -14.969,-1.345 -2.916,0.104 -5.743,0.732 -8.525,1.521 -3.12,0.885 -6.224,1.872 -8.977,3.663 -1.403,0.913 -2.757,1.959 -3.328,3.612 -0.682,1.975 -0.149,3.783 1.18,5.329 2.162,2.514 4.896,4.024 8.2,4.46 4.686,1.406 9.293,0.935 13.827,-0.65 1.621,-0.566 3.181,-1.307 4.769,-1.968 5.265,-2.07 15.702,-8.189 16.821,-8.715 0.027,-0.012 0.051,0.018 0.043,0.047 -0.522,1.861 -0.998,3.628 -1.514,5.382 -1.716,5.832 -2.922,11.771 -3.947,17.76 -1.311,7.664 -1.35,15.382 -0.986,23.097 0.213,4.515 0.773,9.024 1.614,13.48 0.129,0.684 -0.086,1.009 -0.731,0.691 -3.887,-1.915 -7.47,-0.835 -10.871,1.209 -0.936,0.562 -2.158,0.454 -2.934,-0.313 -0.634,-0.627 -1.428,-1.096 -2.137,-1.652 -0.505,-0.397 -1.127,-0.732 -0.397,-1.515 0.645,-0.694 1.311,-1.016 2.087,-0.332 0.673,0.595 1.308,1.209 2.16,1.559 1.126,0.463 2.135,0.146 2.932,-0.969 0.791,-1.106 0.724,-1.77 -0.268,-2.804 -0.877,-0.913 -1.826,-1.763 -2.887,-2.434 -2.648,-1.674 -5.751,-1.016 -7.722,1.642 -0.291,0.393 -0.822,1.292 -0.822,1.292 -1.466,2.36 -2.429,4.913 -2.993,7.631 -0.223,1.074 0.196,1.829 0.994,2.429 2.7,2.027 5.536,3.851 8.831,4.718 2.454,0.646 5.009,0.63 7.54,0.634 1.922,0.002 3.846,0.026 5.767,-0.037 2.029,-0.066 2.767,-0.734 3.394,-2.64 1.908,-5.787 3.121,-11.759 4.727,-17.626 1.49,-5.442 3.346,-10.741 5.418,-15.993 1.98,-5.02 3.203,-10.303 4.271,-15.607 C -0.389,17.035 0.735,10.579 1.112,4.013 1.192,2.602 0.875,1.135 0,0 m -69.908,1.037 c -1.744,-4.271 -3.227,-8.656 -5.845,-12.512 -1.48,-2.18 -2.983,-4.35 -4.845,-6.179 -0.026,0.007 -0.027,0.008 -0.051,0.014 -0.028,1.299 -0.465,22.249 0.162,28.406 0.315,3.088 0.912,6.099 3.009,8.565 2.599,3.057 6.047,4.15 9.897,3.969 3.879,-0.183 7.126,-1.955 10.243,-4.122 0.15,-0.104 1.768,-1.267 0.986,-1.709 -6.622,-3.74 -10.752,-9.564 -13.556,-16.432 M 9.8,4.51 C 9.393,11.92 8.068,19.122 6.846,25.189 5.745,30.657 4.411,36.51 2.138,42.272 c -2.167,5.493 -3.842,10.431 -5.119,15.096 -0.553,2.019 -1.055,4.043 -1.586,6.185 -0.958,3.864 -1.949,7.861 -3.269,11.866 -2.268,6.886 -7.436,8.486 -11.376,8.616 -1.159,0.038 -2.318,0.048 -3.478,0.048 l -2.807,-0.007 c -2.838,-0.004 -6.056,-0.009 -9.521,-0.921 -4.942,-1.301 -8.925,-3.984 -11.841,-6.174 -3.578,-2.688 -5.182,-6.857 -4.29,-11.154 0.781,-3.768 2.149,-7.255 4.066,-10.367 0.348,-0.586 0.836,-1.377 1.28,-1.975 2.865,-3.862 7.122,-6.077 11.678,-6.076 1.932,0 3.849,0.405 5.644,1.183 0.022,0.01 0.045,-0.005 0.044,-0.029 -0.25,-6.485 -0.25,-14.624 1.187,-23.019 0.309,-1.807 0.617,-3.513 0.932,-5.138 -0.161,0.066 -0.325,0.131 -0.487,0.195 -0.43,0.18 -0.858,0.366 -1.287,0.552 -1.155,0.503 -2.465,1.073 -3.882,1.567 -3.746,1.309 -7.445,1.972 -10.996,1.972 -2.262,0 -4.506,-0.282 -6.695,-0.811 -0.012,0.004 -0.021,0.007 -0.033,0.011 -0.678,0.827 -1.552,1.65 -2.672,2.431 -3.571,2.483 -8.481,5.371 -14.801,5.669 -0.407,0.019 -0.81,0.029 -1.21,0.029 -1.791,0 -3.498,-0.214 -5.129,-0.594 l -44.152,-44.026 c 1.119,-1.324 16.415,-18.887 38.129,-16.128 5.478,0.697 12.773,6.568 24.118,4.96 l 0.018,-0.003 0.669,-0.119 c 6.214,-1.118 12.919,-2.17 19.846,-2.29 0.414,-0.008 0.827,-0.011 1.24,-0.011 6.734,0 12.697,0.975 18.229,2.981 5.43,1.968 10.811,4.713 15.997,8.157 l 0.525,0.346 c 1.424,0.934 3.566,2.791 5.363,4.574 0,0 3.931,3.671 3.328,14.642"
            style={{
              fill: colors.blue,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1662"
          />
        </g>
        <g
          id="g1664"
          transform="matrix(0.35277777,0,0,-0.35277777,80.619703,56.58481)"
        >
          <path
            d="M 0,0 V 29.282 H -10.376 V 2.62 l 5.922,-7.075 z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1666"
          />
        </g>
        <g
          id="g1668"
          transform="matrix(0.35277777,0,0,-0.35277777,86.347863,36.58742)"
        >
          <path
            d="M 0,0 H -10.375 V -50.823 L 0,-40.445 Z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1670"
          />
        </g>
        <g
          id="g1672"
          transform="matrix(0.35277777,0,0,-0.35277777,92.076193,31.93273)"
        >
          <path
            d="M 0,0 H -10.376 V -47.776 L 0,-37.398 Z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1674"
          />
        </g>
        <g
          id="g1676"
          transform="matrix(0.35277777,0,0,-0.35277777,94.482073,41.82741)"
        >
          <path
            d="m 0,0 4.437,-4.52 -48.482,-48.492 -11.024,13.169 c -2.386,2.85 -6.691,3.032 -9.307,0.395 l -1.193,-1.203 6.622,-7.854 14.497,-17.193 55.054,54.896 4.096,-4.173 3.724,18.185 z"
            style={{
              fill: colors.blue,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1678"
          />
        </g>
        <g
          id="g1680"
          transform="matrix(0.35277777,0,0,-0.35277777,44.331323,80.79196)"
        >
          <path
            d="m 0,0 h -7.386 l 1.271,5.955 H 16.589 L 15.318,0 H 7.962 l -4.99,-23.544 h -7.963 z"
            style={{
              fill: colors.blue,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1682"
          />
        </g>
        <g
          id="g1684"
          transform="matrix(0.35277777,0,0,-0.35277777,53.228978,83.04176)"
        >
          <path
            d="M 0,0 H 3.42 C 6.493,0 8.023,1.431 8.023,3.861 8.023,6.083 6.437,6.79 4.718,6.79 H 1.429 Z m -1.184,-5.558 -2.45,-11.609 h -7.702 l 6.262,29.5 H 6.648 c 6.329,0 9.484,-3.248 9.484,-7.441 0,-3.999 -2.297,-6.625 -5.673,-7.796 2.169,-1.262 2.903,-3.633 2.007,-7.999 -0.712,-3.326 -0.862,-5.187 -0.945,-6.264 H 3.866 c -0.015,0.915 0.139,2.88 0.973,6.688 0.662,3.075 0.448,4.921 -2.843,4.921 z"
            style={{
              fill: colors.blue,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1686"
          />
        </g>
        <g
          id="g1688"
          transform="matrix(0.35277777,0,0,-0.35277777,65.122634,84.78085)"
        >
          <path
            d="M 0,0 C -0.206,4.435 -0.41,8.942 -0.347,11.982 H -0.526 C -1.814,8.569 -3.607,4.328 -5.597,0 Z m -8.063,-6.152 -2.776,-6.085 h -8.092 c 2.963,5.898 10.559,22.175 14.305,29.499 H 6.023 L 8.158,-12.237 H 0.294 l -0.343,6.085 z"
            style={{
              fill: colors.blue,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1690"
          />
        </g>
        <g
          id="g1692"
          transform="matrix(0.35277777,0,0,-0.35277777,72.277568,87.10439)"
        >
          <path
            d="m 0,0 h 3.578 c 5.761,0 7.928,7.105 7.928,12.002 0,4.374 -2.159,6.14 -5.15,6.14 H 3.864 Z M -2.873,23.849 H 7.516 c 8.231,0 12.285,-5.438 12.285,-12.174 C 19.801,2.658 14.754,-5.65 3.832,-5.65 H -9.135 Z"
            style={{
              fill: colors.blue,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1694"
          />
        </g>
        <g
          id="g1696"
          transform="matrix(0.35277777,0,0,-0.35277777,87.554013,84.80636)"
        >
          <path
            d="m 0,0 h -11.833 l -1.322,-6.253 H 0.8 l -2.019,-5.912 h -20.808 l 6.262,29.499 H 4.171 L 2.9,11.379 H -9.408 L -10.575,5.954 H 1.259 Z"
            style={{
              fill: colors.blue,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1698"
          />
        </g>
        <g
          id="g1700"
          transform="matrix(0.35277777,0,0,-0.35277777,97.035223,78.69113)"
        >
          <path
            d="m 0,0 -4.095,-19.171 c -0.556,-2.607 -0.214,-5.095 3.247,-5.095 3.193,0 4.146,2.306 4.73,5.095 L 7.977,0 h 7.964 L 11.92,-18.932 c -1.397,-6.493 -4.101,-11.119 -13.429,-11.119 -9.21,0 -11.859,4.642 -10.377,11.578 L -7.965,0 Z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1702"
          />
        </g>
        <g
          id="g1704"
          transform="matrix(0.35277777,0,0,-0.35277777,102.28851,89.09772)"
        >
          <path
            d="m 0,0 6.262,29.499 h 9.474 c 0,-10e-4 3.744,-18.941 3.744,-18.941 h 0.147 c 0.431,3.448 1.336,7.873 2.31,12.455 l 1.37,6.486 h 7.181 L 24.225,0 h -9.126 c 0,0 -3.847,20.118 -3.847,20.12 H 11.165 C 10.649,16.414 9.656,11.698 8.566,6.594 L 7.166,0 Z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1706"
          />
        </g>
        <g
          id="g1708"
          transform="matrix(0.35277777,0,0,-0.35277777,118.77932,84.78085)"
        >
          <path
            d="M 0,0 C -0.206,4.435 -0.409,8.942 -0.347,11.982 H -0.526 C -1.813,8.569 -3.606,4.328 -5.596,0 Z m -8.063,-6.152 -2.776,-6.085 h -8.092 c 2.963,5.898 10.559,22.175 14.305,29.499 H 6.023 L 8.158,-12.237 H 0.294 l -0.343,6.085 z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1710"
          />
        </g>
        <g
          id="g1712"
          transform="matrix(0.35277777,0,0,-0.35277777,124.92122,78.69113)"
        >
          <path
            d="M 0,0 H 19.729 L 18.457,-5.939 H 6.491 l -1.225,-5.799 h 11.218 l -1.286,-5.913 H 3.979 L 1.5,-29.499 h -7.763 z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1714"
          />
        </g>
        <g
          id="g1716"
          transform="matrix(0.35277777,0,0,-0.35277777,135.15039,83.04176)"
        >
          <path
            d="M 0,0 H 3.42 C 6.493,0 8.023,1.431 8.023,3.861 8.023,6.083 6.437,6.79 4.719,6.79 H 1.431 Z m -1.183,-5.558 -2.451,-11.609 h -7.701 l 6.261,29.5 H 6.648 c 6.33,0 9.484,-3.248 9.484,-7.441 0,-3.999 -2.297,-6.625 -5.672,-7.796 2.17,-1.262 2.902,-3.633 2.006,-7.999 -0.711,-3.326 -0.862,-5.187 -0.945,-6.264 H 3.867 c -0.016,0.915 0.14,2.88 0.973,6.688 0.661,3.075 0.446,4.921 -2.844,4.921 z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1718"
          />
        </g>
        <g
          id="g1720"
          transform="matrix(0.35277777,0,0,-0.35277777,147.04457,84.78085)"
        >
          <path
            d="M 0,0 C -0.207,4.435 -0.41,8.942 -0.348,11.982 H -0.526 C -1.814,8.569 -3.607,4.328 -5.597,0 Z m -8.063,-6.152 -2.776,-6.085 h -8.093 c 2.963,5.898 10.56,22.175 14.305,29.499 H 6.022 L 8.157,-12.237 H 0.294 l -0.344,6.085 z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1722"
          />
        </g>
        <g
          id="g1724"
          transform="matrix(0.35277777,0,0,-0.35277777,155.98047,78.69113)"
        >
          <path
            d="m 0,0 -6.263,-29.499 h -7.922 L -7.922,0 Z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1726"
          />
        </g>
        <g
          id="g1728"
          transform="matrix(0.35277777,0,0,-0.35277777,158.95601,87.10439)"
        >
          <path
            d="m 0,0 h 3.577 c 5.762,0 7.928,7.105 7.928,12.002 0,4.374 -2.16,6.14 -5.151,6.14 H 3.863 Z M -2.874,23.849 H 7.514 C 15.745,23.849 19.8,18.411 19.8,11.675 19.8,2.658 14.753,-5.65 3.83,-5.65 H -9.137 Z"
            style={{
              fill: colors.green,
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
            id="path1730"
          />
        </g>
      </svg>
    </div>
  );
};

TULogo.propTypes = {
  height: PropTypes.any,
  margin: PropTypes.any,
  width: PropTypes.any
};

export default TULogo;
